export const SIGNALR_RECONNECT_DELAY_MS = 2000;
export const unlimitedReconnectPolicy = {
    nextRetryDelayInMilliseconds: () => SIGNALR_RECONNECT_DELAY_MS,
};
